import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpErrorResponse, HttpResponse, HttpHeaders} from '@angular/common/http';
import {  throwError, Observable, BehaviorSubject, Subject, of } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ErrorsConfig } from './common/errorsconfig/commonerrordetails';
import * as errorData from './../assets/coxErrorDetails.json';
import jwt_decode from 'jwt-decode';
import { APP_Constants } from './app.constant';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalConfig } from './common/modal/modal.config';
import { GenericModalV2Component } from './shared/common/generic-modal-v2/generic-modal-v2.component';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as backenderrorData from '../assets/alphaerrorcodes.json';
import { CookieService } from "ngx-cookie-service";
import moment from 'moment';
import { schemaHasRules } from 'ajv/dist/compile/util';
import {SchemaVal} from '../models/schema.model';
import { ConvertUomPipe } from 'src/app/common/convert-uom.pipe';

const baseUrl = 'http://localhost:2000/api';


@Injectable({
  providedIn: 'root'
})


export class AppService {
  multiLangCustomerList = ['MAR'];
  configCustomerList = ['LLP2GO'];
  ContactList =['TMSLITE','HDNA', 'COLLINS','GSKRD']
  warningDlg: MatDialogRef<GenericModalV2Component>;
  //formConfigData is to pass the complete form configuration data
  formConfigData: any;
  // To Store all the template request information
  templateRequestInfoStore = new Map();
  
  errorMsg = "Your session has timed out due to inactivity. Please log in again to continue accessing your account.";

  inlineSuccessMessage: string | null;
  inlineErrorMessage: string | null;
  isErrorSet : any = false;

  //const transText = this._translate.instant('something');

  constructor(private http: HttpClient, private router: Router, private _translate: TranslateService, private matDialog: MatDialog,
    public cookieService: CookieService, private ConvertUomPipe:ConvertUomPipe) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

        // on route change clear components object to avoid memory leak

        // in case of 500 if any internal api fails for e.g. location search, order filter, whole page will break down because of below change. so hold on, till we get proper solution
        //this._components = {​​​​​​}​​​​​​;

      }
    });
  }

  checkMultiLangSupport() {
    let custCode = localStorage.getItem('customerCode');
    if (this.multiLangCustomerList.indexOf(custCode) > -1) {
      return true;
    }
    return false;
  }

  checkCustomerDropdown(){
    let custCode = localStorage.getItem('customerCode');
if (this.configCustomerList.indexOf(custCode) > -1) {
      return true;
    }
//  return false;
  }
  checkMultipleCustomer() {
    if (localStorage.customerList && JSON.parse(localStorage.customerList).length > 1) {
      return true;
    } else {
      return false;
    }
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }

  private currentUrl;
  private previousUrl;

  private authToken;
  private _shipmentSubject = new Subject<any>();
  public _formErrorCheck = new Subject<any>();
  public _commonSubjecct = new Subject<any>();
  public _modalCommonFormSubjecct = new Subject<any>();
  public _components = {};

  public _navigationSubject = new Subject<any>();
  public _switchCustomerSubject = new Subject<any>();
  public _commonComponentSubject = new Subject<any>();
  public _commonComponentSubjectFilter = new Subject<any>();

  public _stepperContentSubject = new Subject<any>();
  public _stepIndexSub = new Subject<any>();
  public templateChangeSub = new Subject<any>();
  public _valueTransferSub = new Subject<any>();

  private massiveSearchBox = new Subject<any>();
  massiveSearchBox$ = this.massiveSearchBox.asObservable();

  private resetScrollPaginationSubject = new Subject<void>();
  resetScrollPagination$ = this.resetScrollPaginationSubject.asObservable();

  private groupValidationSubscriptionSubject = new Subject<void>();
  groupValidationSubscription$ = this.groupValidationSubscriptionSubject.asObservable();

 private removeWarningMessage = new Subject<{ name: string; reset: boolean; resetWarningMessage?: boolean }>();
  removeWarningMessage$ = this.removeWarningMessage.asObservable();

   
  private validateWhenSelectedProp = new Subject<void>();
  validateWhenSelectedProp$ = this.validateWhenSelectedProp.asObservable();

  private originLocations;
  private destinationLocations;

  sendMassiveSearchBoxData(search: string) {
    this.massiveSearchBox.next(search);
  }

  resetScrollPaginationData() {
    this.resetScrollPaginationSubject.next();
  }

  groupValidationSubscription() {
    this.groupValidationSubscriptionSubject.next();
  }
  
  handleRemoveWarningMessage(data: { name: string; reset: boolean; resetWarningMessage?: boolean }) {
    this.removeWarningMessage.next(data);
  }

  handleValidateWhenSelectedProp() {
    this.validateWhenSelectedProp.next();
  }

  setOriginUsedLocation(data) {
    this.originLocations = data;
  }
  getOriginUsedLocation(){
    return this.originLocations;
  }

  setDestinationUsedLocation(data){
    this.destinationLocations = data;
  }
  getDestinationUsedLocation() {
    return this.destinationLocations;
  }

  get events$ () {
    return this._shipmentSubject.asObservable();
  }

  newEvent(event) {
    this._shipmentSubject.next(event);
  }

  private httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'my-auth-token'
    })
  };
  private httpOptionsNewHeader = {
    headers: new HttpHeaders({
      'Authorization': 'my-auth-token'
    })
  };

  private orderMessage = new BehaviorSubject('We are fetching the order details !');
  currentMessage = this.orderMessage.asObservable();

  private enableFinalStepActionSource = new BehaviorSubject<boolean>(false); // Default value
  enableFinalStepAction$ = this.enableFinalStepActionSource.asObservable();
  updateEnableFinalStepAction(value: boolean) {
    this.enableFinalStepActionSource.next(value);
  }

  setAuthToken(token){
    this.authToken = token;
  }
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }


  private params = new HttpParams();

  // private headers = new Headers({
  //   'Accept': 'application/json',
  //   'Content-Type': 'application/json',
  //   'Authorization' : 'abcde'
  // });

  /**
   * fetchCutomTemplateData
      url: String
  */

  // development purpose

  // makeLocalOrderCreate(url){
  //   let authToken1 = sessionStorage.getItem('authToken');
  //   this.httpOptions.headers =  this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1 );
  //   return this.http.get(environment.localUrl + '/create' , this.httpOptions).pipe(retry(3), catchError(this.handleError));
  // }

  // makeLocalOrderEdit(url){
  //   let authToken1 = sessionStorage.getItem('authToken');
  //   this.httpOptions.headers =  this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1 );
  //   return this.http.get(environment.localUrl + '/edit' , this.httpOptions).pipe(retry(3), catchError(this.handleError));
  // }

  // makeLocalOrderSearch(url){
  //   let authToken1 = localStorage.getItem('authToken');
  //   this.httpOptions.headers =  this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1 );
  //   if(localStorage.getItem('customerCode') === 'HNA')   {
  //     return this.http.get(environment.localUrl + '/HNA/search' , this.httpOptions).pipe(retry(3), catchError(this.handleError));
  //   } else{
  //     return this.http.get(environment.localUrl + '/UTC/rateSearch' , this.httpOptions).pipe(retry(3), catchError(this.handleError));
  //   }
  // }

  // makeLocalConfiguration(url){
  //   let authToken1 = localStorage.getItem('authToken');
  //   this.httpOptions.headers =  this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1 );
  //   return this.http.get(environment.localUrl + '/UTC/rateSearchData' , this.httpOptions).pipe(retry(3), catchError(this.handleError));
  // }


  // makeLocalOrderSearchHNA(url){
  //   let authToken1 = localStorage.getItem('authToken');
  //   this.httpOptions.headers =  this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1 );
  //   return this.http.get(environment.localUrl + url , this.httpOptions).pipe(retry(3), catchError(this.handleError));
  // }

  //  makeLocalHttpRequest(url){
  //    let authToken1 = localStorage.getItem('authToken');
  //    this.httpOptions.headers =  this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1 );
  //    return this.http.get(environment.localService + url , this.httpOptions).pipe(retry(3), catchError(this.handleError));
  //  }

  // makeLocalGetNotes<T>(){
  //   let authToken1 = localStorage.getItem('authToken');
  //   this.httpOptions.headers =  this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1 );
  //   const customerCode = localStorage.getItem('customerCode')
  //   console.log(customerCode)
  //   return this.http.get<T>('http://localhost:2000/getNotesV3', this.httpOptions).pipe(retry(3), catchError(this.handleError));
  // }

  // makeHttpRequestMIMIC(url){
  //   let authToken1 = localStorage.getItem('authToken');
  //   this.httpOptions.headers =  this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1 );
  //   return this.http.get(environment.localUrl + url, this.httpOptions).pipe(retry(3), catchError(this.handleError));
  // }
  //

  // development purpose

  /*
    ***
      making the api call generic and try to remove all other api request
    ***
  */
  makeHttpGetAbsoluteURL(url){
    return this.http.get(url).pipe(retry(1), catchError((error: HttpErrorResponse)=> this.handleError(error)));
  }
  /**
   * name
   */
  public getHeader(extraHeaders?: any) {
    let authToken1 = this.cookieService.get('authToken');

    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + authToken1
    });

    if (extraHeaders) {
      Object.keys(extraHeaders).forEach(key => {
        headers = headers.set(key, extraHeaders[key]);
      });
    }

    return { headers };
  }

  makeHttpGetRequest(url){
    return this.http.get(environment.apiUrl + url, this.getHeader()).pipe(retry(3), catchError((error: HttpErrorResponse)=> this.handleError(error)));
  }

  makeHttpPostRequest(url, data,extraHeaders?: any){
    return this.http.post(environment.apiUrl + url, data, this.getHeader(extraHeaders) ).pipe(retry(3), catchError((error: HttpErrorResponse)=> this.handleError(error)));
  }

  makeHttpPostCallWithoutRetry(url, data){
    return this.http.post(environment.apiUrl + url, data, this.getHeader() );
  }

  makeHttpPutRequest(url, data){
    return this.http.put(environment.apiUrl + url, data, this.getHeader() ).pipe(retry(3), catchError((error: HttpErrorResponse)=> this.handleError(error)));
  }

  //For delete api call services
  makeHttpDeleteRequest(url){
    return this.http.delete(environment.apiUrl + url, this.getHeader()).pipe(retry(3), catchError((error: HttpErrorResponse) => this.handleError(error)));
  }//End

  makeHttpDocRequest(url){
    let authToken1 = this.cookieService.get('authToken');
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + authToken1
      })
    };

    return this.http.get(environment.apiUrl + url, httpOptions).pipe(retry(3), catchError((error: HttpErrorResponse)=> this.handleDocumentError(error)));
  }

  makeHttpTextRequest(url){
    const httpOptions = {
      responseType: 'text/plain' as 'text',
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.cookieService.get('authToken')
      })
    };
    return this.http.get(environment.apiUrl + url, httpOptions).pipe(retry(3), catchError((error: HttpErrorResponse)=> this.handleError(error)));
  }

  /*
    ***
      use url form Encoded parameter for http call
    ***
  */
    makeHttpPostFormUrlEncoded(url, stringBody, token) {

      this.httpOptionsNewHeader.headers =  this.httpOptionsNewHeader.headers.set('Authorization', 'Bearer ' + token );
      this.httpOptionsNewHeader.headers = this.httpOptionsNewHeader.headers.set('Content-Type', 'application/x-www-form-urlencoded');
      return this.http.post(environment.apiUrl + url, stringBody, this.httpOptionsNewHeader).pipe(retry(3), catchError((error: HttpErrorResponse)=> this.handleError(error)));
    }

    getRefreshTokenSilently(){
      let tokenPayloadString = 'username=' + localStorage.getItem('userName');
      let authToken1 = this.cookieService.get('authToken');
      this.httpOptionsNewHeader.headers =  this.httpOptionsNewHeader.headers.set('Authorization', 'Bearer ' + authToken1 );
      // this.httpOptions.headers.headers.clear();
      this.httpOptionsNewHeader.headers = this.httpOptionsNewHeader.headers.set('Content-Type', 'application/x-www-form-urlencoded');
      return this.http.post(environment.apiUrl + '/authservice/refresh', tokenPayloadString, this.httpOptionsNewHeader ).pipe(retry(3), catchError((error: HttpErrorResponse)=> this.handleError(error)));
    }

  // need to remove below method
  makeHttpFileUploadRequest(url, data) {
    let authToken1 = localStorage.getItem('authToken');
    this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + authToken1);
    const formData: FormData = new FormData();
    if (this.fileData)
      formData.append('file', this.fileData, this.fileData.name);

    let req = {'key1': 'value1', 'key2': 'value2'};

    formData.append('requestData', JSON.stringify(req));

    return this.http.post(environment.apiUrl + url, formData, this.getHeader()).pipe(retry(3), catchError((error: HttpErrorResponse)=> this.handleError(error)));
  }

  makeHttpGetRequestWithNoError(url) {
    return this.http.get(environment.apiUrl + url, this.getHeader()).pipe(retry(3), catchError((error) => this.handleErrorNoThrow(error)));
  }

  handleErrorNoThrow(error: HttpErrorResponse) {
    return of(error);
  }
  /*
    ***
      making the api call generic and try to remove all other api request
    ***
  */

  private handleDocumentError(err: HttpErrorResponse) {
    return throwError(err);
  }

  public getItemData(url, data) {
    this.params.set('searchString', data.searchText);
    this.params.set('customerCode', data.customerCode);
    // return this.http.post<DhlFormTemplate>('http://localhost:1000/itemSearch', data, {observe: 'response'});
    return this.http.post(environment.apiUrl + url, this.params).pipe( retry(3), catchError((error: HttpErrorResponse)=> this.handleError(error)));
  }

  // private parseErrorBlob(err: HttpErrorResponse): Observable<any> {
  //   const reader: FileReader = new FileReader();

  //   const obs = Observable.create((observer: any) => {
  //     reader.onloadend = (e) => {
  //       observer.error(JSON.parse(reader.result));
  //       observer.complete();
  //     }
  //   });
  //   reader.readAsText(err.error);
  //   return obs;
  // }

  private handleError(error: HttpErrorResponse) {
    let url = error.url;
    let splittedUrl = url.split('/');
    let serviceName = splittedUrl[3]
    serviceName = serviceName.split("-").join(" ");
    serviceName = serviceName.charAt(0).toUpperCase() + serviceName.slice(1)
    let ompFlag = false;
    let found = false;
    let topFlag = false;
    this.errorMsg = ErrorsConfig.SERVER_ERROR.MESSAGE;
    if (error.error.message != undefined && error.error.message != null) {
      if (error.error.message.errorSource === "omp") {
        ompFlag = true;
        let ec = error.error.message.errorCode;
        let codes: any = (errorData as any).default;
        codes.forEach(code => {
          if (code.errCode === ec)
          {
            this.errorMsg = code.value;
            found= true;
          }
        });
        if(found === false)
          {
           if (error.error.message.errorMessage)
            this.errorMsg = error.error.message.errorMessage
          else
            this.errorMsg = ErrorsConfig.SERVER_ERROR.MESSAGE;
        };
      }
      if (error.error.message.errorSource === "top") {
        topFlag = true;
        let topec = error.error.message.errorCode;
        let topcodes: any = (backenderrorData as any).default;
        if (Array.isArray(topcodes)) {
          topcodes.find(code => {
            if (code.errorCode === topec)
              this.errorMsg = code.statusMessage;
            if (error.error.message.orderId) {
              this.errorMsg = this._translate.instant('popup_msg.errordescription.01027', { value: error.error.message.orderId })
            }
          });
        }
      }

    }
    if (error.error instanceof ErrorEvent) {
      console.error('Front End error: ', error.error.message);
      return throwError({ 'status': error.status, 'message': error.error.message });
    } else {
      // this.currentHttpCall.statusCode = error.status;
      localStorage.setItem('statusCode', error.status.toString());
      // this.currentHttpCall.responseMessage = error.error.message.statusMessage;
      if (error.status === 401 || error.status === 403 || error.status === 503 || error.status === 404 || error.status === 400 || error.status === 409) {
        // 401 case
        // user not authneticated
        // invalid creds
        // show modal with close button and redirect in case of no action after 20 seconds
        // make logout and return to login page

        // 403 case
        // if user have no role
        // for e.g. cancelling in case of planned order
        // modal box with message and redirect to user home page(eg /order)

        // 503 case
        // service unavailable
        // The server is currently unable to handle the request due to a temporary overload or scheduled maintenance,
        // which will likely be alleviated after some delay.
        if(error.error.message !== undefined){
          if(error.error.message.statusMessage == "Expired JWT"){
           return throwError({'status': error.status, 'message': ErrorsConfig.SESSION_ERROR.MESSAGE});
          } else if(error?.error?.results){
              return throwError({'status': error.status, 'message':error?.error});
          } 
          else{
          if (ompFlag)
            return throwError({ 'data':error.error.data,'status': error.status, 'message': this.errorMsg });
            if (topFlag)
              return throwError({ 'status': error.status, 'message': this.errorMsg });
            else
            return throwError({'status': error.status, 'message':error.error.message.statusMessage});
          }
        } else {
          return throwError({ 'status': error.status, 'message': this.errorMsg });
        }

      } else if (error.status === 500) {
        //	backend failure
        //  modal box with message ...
        //  Something bad happened. Please try again later.
        //  redirect to user home page
        if(error.error.message !== undefined){
          if(error.error.message == "Expired JWT"){
            return throwError({'status': error.status, 'message': ErrorsConfig.SESSION_ERROR.MESSAGE});
          } else {
            if (ompFlag)
              return throwError({ 'status': error.status, 'message': this.errorMsg });
            if (topFlag)
              return throwError({ 'status': error.status, 'message': this.errorMsg });
            else
              return throwError({ 'status': error.status, 'message': error.error.message.statusMessage });
          }
        } else {
          return throwError({'status': error.status, 'message': serviceName + ' is not available'});
        }
      // CP-5144 start - WAF error handling
      } else if(error.status === 200 && error.error && error.error !== undefined && error.error.text !== undefined && error.error.text.includes("Request Rejected")){
        let WAFErrorString = (error.error.text).replace(/<[^>]+>/g, '');
        let supportID = WAFErrorString.match(/(\d+)/);
        return throwError({'status': error.status, 'message': 'The requested URL has been rejected. Please raise a support ticket to DHL with the support ID: ' + supportID[0]});
      }
      
      else{
        return throwError({'status': error.status, 'message':ErrorsConfig.SERVER_ERROR.MESSAGE });
      }
      console.error(error.error);
    }
  }


  public changeMessage(message: string) {
    this.orderMessage.next(message)
  }


  private searchResultData;
  public setSearchResultMetaData(data) {
    this.searchResultData = data;
  }
  public getSearchResultMetaData() {
    return this.searchResultData;
  }

  private orderTemplate;
  public setOrderTemplate(data) {
    this.orderTemplate = data;
  }
  public getOrderTemplate() {
    return this.orderTemplate;
  }

  private orderData;
  public setOrderDetails(data) {
    this.orderData = data;
  }
  public getOrderDetails() {
    return this.orderData;
  }

  rateLookupEnquiry;
  rateLookupResult;

  public setRateLookupEnquiry(data) {
    this.rateLookupEnquiry = data;
  }
  public getRateLookupEnquiry() {
    return this.rateLookupEnquiry;
  }

  public setRateLookupResult(data) {
    this.rateLookupResult = data;
  }
  public getRateLookupResult() {
    return this.rateLookupResult;
  }

  private fileData;
  public setUploadFileData(data) {
    this.fileData = data;
  }
  public getUploadFileData() {
    return this.fileData;
  }

  private rawFormValue;
  public setRawFormValue(data) {
    this.rawFormValue = data;
  }

  public getRawFormValue() {
    return this.rawFormValue;
  }

  public getCurrentDateAndTime() {
    return new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString();
  }
  quotationSearchRequest;
  quotationSearchResult;

  public setQuotationSearchRequest(data) {
    this.quotationSearchRequest = data;
  }
  public getQuotationSearchRequest() {
    return this.quotationSearchRequest;
  }
  public setQuotationSearchResult(data) {
    this.quotationSearchResult = data;
  }
  public getQuotationSearchResult() {
    return this.quotationSearchResult;
  }

  commonObject;
  public setcommonObject(data) {
    this.commonObject = data;
  }
  public getcommonObject() {
    return this.commonObject;
  }

  // Disable side menu until data gets load
  sideMenuDisable() {
    if(document.getElementById("sideMenuID")){
      document.getElementById("sideMenuID").style.opacity = '0.6';
      document.getElementById("sideMenuID").style.pointerEvents = 'none';
    }
  }

  // Enable side menu after data load
  sideMenuEnable() {
    if(document.getElementById("sideMenuID")){
      document.getElementById("sideMenuID").style.opacity = '1';
      document.getElementById("sideMenuID").style.pointerEvents = 'inherit';
    }
  }

    public compareTwoDates(e, configData, frmGroup, reValidateOtherField = true) {

    // generic date validation
    let name = configData.name;
    let fieldValue = frmGroup.get(name).value;
    let fieldError = false;
    let nextFieldValue, nextField, error, nextFieldLabel;

    // If current field is empty, clear its own errors and also clear errors on any paired date fields
    if (!fieldValue || fieldValue === '') {
      if (configData?.required && frmGroup.get(name)?.value === '') {
        frmGroup.get(name).setErrors({ required: true });
        frmGroup.get(name).updateValueAndValidity();
      } else {
        frmGroup.get(name).setErrors(null);
      }
      if (configData.validation) {
        for (const check in configData.validation) {
          const parts = configData.validation[check].split('-');
          // Clear paired fields from before/after validations on this field
          if ((parts[0] === 'before' || parts[0] === 'after') && parts[1]) {
            const pairedControl = frmGroup.get(parts[1]);
            // if (pairedControl) pairedControl.setErrors(null);
          }
          // Clear all fields listed in dateSorting validation
          if (parts[0] === 'dateSorting') {
            parts.slice(1).forEach(fieldName => {
              const ctrl = frmGroup.get(fieldName);
              if (ctrl && ctrl.errors && ctrl.errors['type'] === 'dateSorting') ctrl.setErrors(null);
            });
          }
        }
      }
      // Reverse lookup: find all OTHER fields in the form that reference this field
      // in their own before/after/dateSorting validations and clear their errors too
      Object.keys(frmGroup.controls).forEach(controlName => {
        if (controlName === name) return;
        const otherConfig = this._components[controlName]?.configData;
        const validation = otherConfig?.validation;
        if (!validation || Array.isArray(validation)) {
          return;
        }
        for (const check in validation) {
          const parts = validation[check].split('-');
          const referencesCurrentField = parts.slice(1).includes(name);
          if (!referencesCurrentField) continue;
          if (parts[0] === 'before' || parts[0] === 'after') {
            frmGroup.get(controlName)?.setErrors(null);
          }
          if (parts[0] === 'dateSorting') {
            const ctrl = frmGroup.get(controlName);
            if (ctrl?.errors?.['type'] === 'dateSorting') {
              ctrl.setErrors(null);
            }
          }
        }
      });
      return { 'error': false };
    }
    if (configData?.showDefaultTime) {
      let valid = new RegExp(/ (0[8-9]|1[0-7]):[0-5][0-9]| 18:00$/)
      if (fieldValue && !fieldValue?.match(valid)) {
        let error = {
          message: {
            configDataLabel: configData?.label,
            additionalLabel: "time must be between 08:00 and 18:00",
          },
        };
        error[name] = true;
        frmGroup.get(name).markAsTouched();
        frmGroup.get(name).setErrors(error);
        fieldError = true;
        return { 'error': true, message: error.message };
      }
    }
    //validation for 24 hr date format
    if (fieldValue && fieldValue?.length > 0 && configData?.displayFormat && configData?.displayFormat.substr(configData.displayFormat.length - 5) == "HH:mm") {
      let valid = new RegExp(/^([01]\d|2[0-3]):?([0-5]\d)$/)
      let displayFormatLen = configData?.displayFormat.length
      if (!valid.test(fieldValue.substr(fieldValue.length - 5)) || fieldValue.length !== displayFormatLen || !moment(fieldValue, configData.displayFormat, true).isValid()) {
        let error = {
          message: {
            "configDataLabel": configData.dateFormatErrorMessage || "MAR.SEARCH_ORDER.searchFilter.wrongDateError",
            "dateFormat": !configData.dateFormatErrorMessage ? configData.placeHolder : ""
          }
        }
        console.log(error)
        error[name] = true;
        frmGroup.get(name).markAsTouched();
        frmGroup.get(name).setErrors(error);   // change in html
        fieldError = true;
        return { 'error': true, message: error.message };
      }
    }
    //CP-2434 : if datepicker value is object type
    if (typeof fieldValue == 'object' && fieldValue) {
      fieldValue = fieldValue.value;
    }

    //CP-2434 : if datepicker value is object type
    if (typeof fieldValue == 'object' && fieldValue) {
      fieldValue = fieldValue.value;
    }
    fieldValue = fieldValue && configData?.displayFormat ? moment(fieldValue, configData?.displayFormat).format('MM/DD/YYYY hh:mm A') : fieldValue;
    if (fieldValue) {
      for (const check in configData.validation) {
        let validationCheck = configData.validation[check].split('-');
        if (validationCheck[0] === 'dateFormat') {
          let regex = "";
          regex = validationCheck[1];
          let dateReg = new RegExp(regex)
          if (isNaN(Date.parse(fieldValue)) || !fieldValue.match(dateReg)) {
            let error = {
              message: {
                "configDataLabel": configData.dateFormatErrorMessage || "MAR.SEARCH_ORDER.searchFilter.wrongDateError",
                "dateFormat": !configData.dateFormatErrorMessage ? configData.placeHolder : ""
              }
            }
            console.log(error)
            error[name] = true;
            frmGroup.get(name).markAsTouched();
            frmGroup.get(name).setErrors(error);   // change in html
            fieldError = true;
            return { 'error': true, message: error.message };
          }
        }

        if (validationCheck[0] === 'timeAfter') {
          const now = moment();
          const inputMoment = moment(fieldValue);
          const isSameDay = inputMoment.isSame(now, 'day');

          if (isSameDay && (inputMoment.isSame(now, 'minute') || inputMoment.isAfter(now, 'minute'))) {
            let error = {
              message: {
                configDataLabel: configData.label,
                additionalLabel: "time cannot be greater than current time for today.",
              },
            };
            error[name] = true;
            frmGroup.get(name).markAsTouched();
            frmGroup.get(name).setErrors(error);
            fieldError = true;
            return { 'error': true, message: error.message };
          }

        }

        if (validationCheck[0] === 'after') {
          let nextFieldValue;
          let nextField;
          if (validationCheck[2] && frmGroup.parent['componentType'] == 'WRAPPER')
            nextField = frmGroup.parent.parent.get(validationCheck[2])['controls'][0].get(validationCheck[1]).value;
          else
            nextField = frmGroup.get(validationCheck[1]).value;

          nextFieldValue = nextField;

          //CP-2434 : if datepicker value is object type
          if (typeof nextFieldValue == 'object' && nextFieldValue) {
            nextFieldValue = nextFieldValue.value;
          }

          nextFieldValue = configData?.displayFormat ? moment(nextFieldValue, configData?.displayFormat).format('MM/DD/YYYY hh:mm A') : nextFieldValue;
          // if(!(configData.type === 'insertDate') && event.type === 'click'){
          //   // nextField['maxDate'] = fieldValue;    // add maxDate in datepicker
          // }

          // Only validate if both fields have a value
          if(nextFieldValue && fieldValue && (+new Date(fieldValue) < +new Date(nextFieldValue))) {
            let nextFieldLabel = this._components[validationCheck[1]].configData.label;
            let dynamicMsg = typeof configData?.errorMessage == 'object' ? configData?.errorMessage[validationCheck[0]] : configData?.errorMessage;
            let error = {
             message: {"configDataLabel": configData.label, "additionalLabel": dynamicMsg, "fieldLabel": nextFieldLabel},
            }
            error[name] = true;
            frmGroup.get(name).markAsTouched();
            frmGroup.get(name).setErrors(error);   // change in html
            fieldError = true;
            return {'error': true,  message : error.message};
          } else if (!fieldValue && !this._components[name].configData?.required || !nextFieldValue && !this._components[validationCheck[1]].configData?.required) {
            frmGroup.get(name).setErrors(null);
            frmGroup.get(validationCheck[1]).setErrors(null);
          } else {
            if (reValidateOtherField && nextFieldValue) {
              const validity = this.compareTwoDates(null, this._components[validationCheck[1]].configData, frmGroup, false);
              if (!validity.error) {
                frmGroup.get(validationCheck[1]).updateValueAndValidity();
              }
            } else if (nextFieldValue) {
              frmGroup.get(validationCheck[1]).updateValueAndValidity();
            }
          }
        }

        if (validationCheck[0] === 'before') {
          let nextFieldValue;
          let nextField;
          if (validationCheck[2] && frmGroup.parent['componentType'] == 'WRAPPER') {
            nextField = frmGroup.parent.parent.get(validationCheck[2])['controls'][0].get(validationCheck[1]);
          } else {
            nextField = frmGroup.get(validationCheck[1]);
          }
          nextFieldValue = nextField.value;

          //CP-2434 : if datepicker value is object type
          if (typeof nextFieldValue == 'object' && nextFieldValue) {
            nextFieldValue = nextFieldValue.value;
          }

          nextFieldValue = configData?.displayFormat ? moment(nextFieldValue, configData?.displayFormat).format('MM/DD/YYYY hh:mm A') : nextFieldValue;

          // if (!(configData.type === 'insertDate') && event.type === 'click') {
          //   // if (nextFieldValue && fieldValue && (+ new Date(fieldValue) > + new Date(nextFieldValue))) {
          //   //   nextField.setValue(null);
          //   //   nextField.updateValueAndValidity()
          //   //   // nextFieldValue = fieldValue;
          //   // }
          // }

          // Only validate if both fields have a value
          if (nextFieldValue && fieldValue && (+new Date(fieldValue) > +new Date(nextFieldValue))) {
            let nextFieldLabel = this._components[validationCheck[1]].configData.label;
            let dynamicMsg = typeof configData?.errorMessage == 'object' ? configData?.errorMessage[validationCheck[0]] : configData?.errorMessage;
            let error = {
              message: { "configDataLabel": configData.label, "additionalLabel": dynamicMsg, "fieldLabel": nextFieldLabel },
              // message: "Pickup date cannot later than Requested delivery date",
            }
            error[name] = true;
            frmGroup.get(name).markAsTouched();
            frmGroup.get(name).setErrors(error);   // change in html
            fieldError = true;
            return { 'error': true, message: error.message };
          } else if (!fieldValue && !this._components[name].configData?.required || !nextFieldValue && !this._components[validationCheck[1]].configData?.required) {
            frmGroup.get(name).setErrors(null);
            frmGroup.get(validationCheck[1]).setErrors(null);
          } else {
            if (reValidateOtherField && nextFieldValue) {
              const validity = this.compareTwoDates(null, this._components[validationCheck[1]].configData, frmGroup, false);
              if (!validity.error) {
                frmGroup.get(validationCheck[1]).updateValueAndValidity();
              }
            } else if (nextFieldValue) {
              frmGroup.get(validationCheck[1]).updateValueAndValidity();
            }
          }
        }

        if (validationCheck[0] === 'checkOffsetTime') {
          if (validationCheck[2] && frmGroup.parent['componentType'] == 'WRAPPER')
            nextField = frmGroup.parent.parent.get(validationCheck[2])['controls'][0].get(validationCheck[1]);
          else
            nextField = frmGroup.get(validationCheck[1]);
            nextFieldValue = nextField.value;

          if (typeof nextFieldValue == 'object' && nextFieldValue)
            nextFieldValue = nextFieldValue.value;

          nextFieldValue = configData?.displayFormat ? moment(nextFieldValue, configData?.displayFormat).format('MM/DD/YYYY hh:mm A') : nextFieldValue;

          if (fieldValue && nextFieldValue && configData?.offsetMinutes && configData?.timePicker) {
            let minutes = moment(fieldValue).diff(moment(nextFieldValue), 'minutes', false);
            if (Math.abs(minutes) <= configData.offsetMinutes) {
              nextFieldLabel = this._components[validationCheck[1]].configData.label;
              error = {
                message: { "configDataLabel": "", "additionalLabel": configData.offsetErrorMessage, "fieldLabel": "" },
              }
              error[name] = true;
              frmGroup.get(name).markAsTouched();
              frmGroup.get(name).setErrors(error);   // change in html
              fieldError = true;
              return { 'error': true, message: error.message };
            }
          } else {
            if (reValidateOtherField) {
              const validity = this.compareTwoDates(null, this._components[validationCheck[1]].configData, frmGroup, false);
              if (!validity.error) {
                frmGroup.get(validationCheck[1]).updateValueAndValidity();
              }
            } else {
              frmGroup.get(validationCheck[1]).updateValueAndValidity();
            }
          }
        }
        if (validationCheck[0] == "offsetDeff") {
          let dateFormat = validationCheck[3] == 'days' ? configData.displayFormat.split(" ")[0] : configData.displayFormat;
          let dateFieldName1 = moment(frmGroup.get(validationCheck[1]).value, dateFormat);
          let dateFieldName2 = moment(frmGroup.get(validationCheck[4]).value, dateFormat);
          let duration = dateFieldName2.diff(dateFieldName1, validationCheck[3]);
          console.log(duration, dateFieldName2, dateFieldName1, dateFormat, "<===duration < +validationCheck[2]duration < +validationCheck[2]");
          if (duration < +validationCheck[2]) {
            let dynamicMessage = validationCheck[2] == 'days' ? validationCheck[2] * 24 + ' ' + 'hours' : validationCheck[2] + ' ' + validationCheck[3];
            let deliveryWindow = `Delivery window is less than ${dynamicMessage}`;
            let error = {
              message: { "additionalLabel": deliveryWindow },
            }
            error[name] = true;
            error['type'] = 'offsetDeff';
            frmGroup.get(name).markAsTouched();
            frmGroup.get(name).setErrors(error);   // change in html
            fieldError = true;
            return { 'error': true, message: error.message };
          } else {
            if (validationCheck[1] && frmGroup.get(validationCheck[1])?.errors?.type == 'offsetDeff') frmGroup.get(validationCheck[1]).setErrors(null);
            if (validationCheck[4] && frmGroup.get(validationCheck[4])?.errors?.type == 'offsetDeff') frmGroup.get(validationCheck[4]).setErrors(null);
          }
        }

        if (validationCheck[0] == "offsetUTC") {
          if (validationCheck[4] == "systemDateTime") {
            let addObj = {};
            let addSubNum = validationCheck[1] == "add" ? validationCheck[2] : '-' + validationCheck[2]
            addObj[validationCheck[3]] = addSubNum
            let countryTime = moment().utc().add(addObj).format("HH:mm");
            let cutoffTime = moment(validationCheck[6], 'HH:mm');
            let timeStatus = moment(countryTime, "HH:mm").isBefore(cutoffTime);
            let dateFormat = validationCheck[8] == 'days' ? configData.displayFormat.split(" ")[0] : configData.displayFormat;
            let currentCompData = moment(frmGroup.get(configData.name).value, dateFormat);
            let compareDate = moment().format(dateFormat);
            let duration = Math.abs(currentCompData.diff(moment(compareDate, dateFormat), validationCheck[8]));
            let compareValidDuration = timeStatus ? validationCheck[7] : validationCheck[10];
            if (duration < compareValidDuration) {
              let hrs24 = compareValidDuration * 24;
              let deliveryWindow = `Delivery window is less than ${hrs24} hours`
              let error = {
                message: { "additionalLabel": deliveryWindow },
              }
              error[name] = true;
              error['type'] = 'offsetUTC';
              frmGroup.get(name).markAsTouched();
              frmGroup.get(name).setErrors(error);   // change in html
              fieldError = true;
              return { 'error': true, message: error.message };
            }
            else {
              if (name && frmGroup.get(name)?.errors?.type == 'offsetUTC') frmGroup.get(name).setErrors(null);
            }
          }
        }

        if (validationCheck[0] == "disablePastDate" && configData.enableStepperValidation) {
          const today = moment().startOf('day');
          const inputDate = moment(fieldValue, configData.displayFormat).startOf('day');

          if (inputDate.isBefore(today)) {
            let error = {
              message: {
                "configDataLabel": configData.label,
                "additionalLabel": configData.pastDateErrorMessage || "cannot be in the past",
                "fieldLabel": ""
              }
            }
            error[name] = true;
            frmGroup.get(name).markAsTouched();
            frmGroup.get(name).setErrors(error);
            fieldError = true;
            return { 'error': true, message: error.message };
          }
        }

        if (validationCheck[0] == "dateSorting") {
          let arrayOfFieldsName = configData.validation[check].split('-'); //Get array of firld Name
          let dateData0, dateData1, dateData2, dateData3, dateCompare1, dateCompare2, dateCompare3, error;
          dateData0 = frmGroup.get(arrayOfFieldsName[1]).value; // 1st field value
          dateData1 = frmGroup.get(arrayOfFieldsName[2]).value;// 2nd field value
          //1st & 2nd fields comparison 
          dateCompare1 = moment(dateData0, configData.displayFormat).isSameOrBefore(moment(dateData1, configData.displayFormat));
          if (!dateCompare1) {
            if (arrayOfFieldsName[1] == name) {
              let fieldLabel = this._components[arrayOfFieldsName[2]].configData.label;
              error = {
                message: { "additionalLabel": `${configData.label} should less than ${fieldLabel}` },
              }
              error["type"] = "dateSorting";
              this.setErrorFn(error, frmGroup, name);
            }
            else if (arrayOfFieldsName[2] == name) {
              let fieldLabel = this._components[arrayOfFieldsName[1]].configData.label
              error = {
                message: { "additionalLabel": `${configData.label} should greater than ${fieldLabel}` },
              }
              error["type"] = "dateSorting";
              this.setErrorFn(error, frmGroup, name);
            }
          }
          if (arrayOfFieldsName?.length > 3) {
            dateData2 = frmGroup.get(arrayOfFieldsName[3]).value; // 3rd field value
            //2st & 3nd fields comparison 
            dateCompare2 = moment(dateData1, configData.displayFormat).isSameOrBefore(moment(dateData2, configData.displayFormat));
            if (!dateCompare2) {
              if (arrayOfFieldsName[2] == name) {
                let fieldLabel = this._components[arrayOfFieldsName[3]].configData.label;
                error = {
                  message: { "additionalLabel": `${configData.label} should less than ${fieldLabel}` },
                }
                error["type"] = "dateSorting";
                this.setErrorFn(error, frmGroup, name);
              } else if (arrayOfFieldsName[3] == name) {
                let fieldLabel = this._components[arrayOfFieldsName[2]].configData.label;
                error = {
                  message: { "additionalLabel": `${configData.label} should greater than ${fieldLabel}` },
                }
                error["type"] = "dateSorting";
                this.setErrorFn(error, frmGroup, name);
              }
            }
          }
          if (arrayOfFieldsName?.length > 4) {
            //3rd & 4th fields comparison 
            dateData3 = frmGroup.get(arrayOfFieldsName[4]).value; // 4th field value
            dateCompare3 = moment(dateData2, configData.displayFormat).isSameOrBefore(moment(dateData3, configData.displayFormat));
            if (!dateCompare3) {
              if (arrayOfFieldsName[3] == name) {
                let fieldLabel = this._components[arrayOfFieldsName[4]].configData.label;
                error = {
                  message: { "additionalLabel": `${configData.label} should less than ${fieldLabel}` },
                }
                error["type"] = "dateSorting";
                this.setErrorFn(error, frmGroup, name);
              } else if (arrayOfFieldsName[4] == name) {
                let fieldLabel = this._components[arrayOfFieldsName[3]].configData.label;
                error = {
                  message: { "additionalLabel": `${configData.label} should greater than ${fieldLabel}` },
                }
                error["type"] = "dateSorting";
                this.setErrorFn(error, frmGroup, name);
              };
            }
          }

          const toDateFormat = moment(new Date()).format(configData.displayFormat);
          let disablePastDate = moment(toDateFormat, configData.displayFormat).isSameOrBefore(moment(frmGroup.get(arrayOfFieldsName[1]).value, configData.displayFormat));
          if (dateCompare1 && dateCompare2 && dateCompare3 && disablePastDate) {
            if (arrayOfFieldsName[1] && frmGroup.get(arrayOfFieldsName[1])?.errors?.type == 'dateSorting') frmGroup.get(arrayOfFieldsName[1]).setErrors(null);
            if (arrayOfFieldsName[2] && frmGroup.get(arrayOfFieldsName[2])?.errors?.type == 'dateSorting') frmGroup.get(arrayOfFieldsName[2]).setErrors(null);
            if (arrayOfFieldsName[3] && frmGroup.get(arrayOfFieldsName[3])?.errors?.type == 'dateSorting') frmGroup.get(arrayOfFieldsName[3]).setErrors(null);
            if (arrayOfFieldsName[4] && frmGroup.get(arrayOfFieldsName[4])?.errors?.type == 'dateSorting') frmGroup.get(arrayOfFieldsName[4]).setErrors(null);
          }
        }

        if (validationCheck[0] == "cutOffDateTimeValidation" && configData?.dateValidation?.isEnableChangeValidation) {
          let validateObj = configData?.dateValidation;
          let validationMsg = validateObj?.validationMsg;
          let calculatedDate, addedDays, addedDaysKey:any;
          const dependencyField = configData?.dependencyField;
          const dependencyControl = dependencyField ? frmGroup.get(dependencyField?.key)?.value : null;
          const expediteFieldValue = dependencyControl?.value ? dependencyControl?.value : dependencyControl
          
          if (validateObj && !(dependencyField && expediteFieldValue !== dependencyField?.value)) {
            const now = validateObj?.useSystemTime ? moment().add(validateObj?.addInUTC) : moment().utc().add(validateObj?.addInUTC);
            let currentDay = now.format('ddd').toUpperCase();
             if (validateObj?.cuttOffWeekend?.indexOf(currentDay) > -1 && validateObj?.cuttOfDayFallOn[currentDay] !== undefined) {
              addedDaysKey = currentDay === 'SAT' ? 'cuttOffTimeSaturday' : 'cuttOffTimeSunday';
              calculatedDate = now.clone().add(validateObj?.cuttOfDayFallOn[currentDay], 'days').set(validateObj?.defaultTime);
            } else {
              let getFormatedTime = moment(validateObj?.cuttOffTime, validateObj?.timeFormat); //Get the current time
              let getCurrentUTCTime = now.format(validateObj?.timeFormat); //get the current time (respects useSystemTime, same source as currentDay)
              let cutOffTimeVailidation = moment(getCurrentUTCTime, "HH:mm").isAfter(getFormatedTime);
               if (validateObj?.specialCutOffDays?.includes(currentDay) &&
                 cutOffTimeVailidation &&
                 validateObj?.specialCutoffFallOn?.[currentDay]) {
                 addedDays = {
                   days: validateObj?.specialCutoffFallOn[currentDay]
                 };
                 addedDaysKey = 'cuttOffTimeAfterFriday';
                 calculatedDate = now.clone()
                   .add(validateObj?.specialCutoffFallOn[currentDay], 'days')
                   .set(validateObj?.defaultTime);
               } else {
                 addedDays = cutOffTimeVailidation ? validateObj?.cuttOffTimeAfter : validateObj?.cuttOffTimeBefore;
               }
              calculatedDate = now.clone().add(addedDays).set(validateObj?.defaultTime);
              while (!validateObj?.allowWeekendDates && validateObj?.cuttOffWeekend.indexOf(calculatedDate?.format('ddd').toUpperCase()) > -1) {
                calculatedDate = calculatedDate.add(addedDays, "days");
              }
          }
            let selectedDate = moment(frmGroup.get(name).value, configData.displayFormat); //convert it into moment
            let selectedTimeString = moment(selectedDate, validateObj?.timeFormat).format(validateObj?.timeFormat); //Get time String
            let selectedTime = moment(selectedTimeString, validateObj?.timeFormat); //convert time string into date
            let startTimeString = moment(validateObj?.timeWindow?.startTime).format(validateObj?.timeFormat); //Get default time String
            let endTimeString = moment(validateObj?.timeWindow?.endTime).format(validateObj?.timeFormat); //Get default time String
            let startTime = moment(startTimeString, validateObj?.timeFormat); //convert default time String into moment
            let endTime = moment(endTimeString, validateObj?.timeFormat); //convert default time String into moment

            let checkTimeWindow = selectedTime.isBetween(startTime, endTime) ? true : (selectedTime.isSame(startTime) ? true : selectedTime.isSame(endTime));
            let nextFieldDate = validateObj?.isSameDate ? moment(frmGroup.get(validateObj.isSameDate)?.value, configData.displayFormat) : null;
            let isSameDate = validateObj?.isSameDate ? moment(selectedDate).isSame(nextFieldDate, 'day') : true;

            //check cut Off Weekend
            if (!validateObj?.allowWeekendDates && validateObj?.cuttOffWeekend.indexOf(selectedDate?.format('ddd').toUpperCase()) > -1) {
              return this.showError("cutOffWeekend", validationMsg?.cuttOffWeekend, frmGroup, name);
            }

            //check cut off date form UTC
            if (validateObj?.offsetDateTimeFrom == 'systime') {
              if (moment(selectedDate).isBefore(calculatedDate, 'day')) {
                let errorMessage = validationMsg?.[addedDaysKey] || ((addedDays?.days == validateObj?.cuttOffTimeAfter?.days) ? validationMsg?.cuttOffTimeAfter : validationMsg?.cuttOffTimeBefore);
                return this.showError("cutOffDate", errorMessage, frmGroup, name);
              }
            } else {
              let componentDate = frmGroup.get(validateObj?.offsetDateTimeFrom).value;
              calculatedDate = moment(componentDate, validateObj?.dateFormat).add(addedDays).set(validateObj?.defaultTime);
              if (moment(selectedDate).isBefore(calculatedDate, 'day')) {
                return this.showError("cutOffDate", validationMsg?.cuttOffTimeAfter, frmGroup, name);
              }
            }

            //Collection/Delivery date should be same
            if (validateObj?.isSameDate && !isSameDate) {
              return this.showError("cutOffDate", validationMsg?.isSameDate, frmGroup, name);
            }

            //Check Time Window
            if (validateObj?.timeWindow && !checkTimeWindow) {
              return this.showError("timeWindow", validationMsg?.timeWindow, frmGroup, name);
            }
          }
        }
        
        //Start-Check Past and future date validation for alpha
        if (configData?.dateEnabled) {
          let name = configData.name
          let editableFromDate = configData?.dateEnabled?.from == 'today' ? moment() : moment(frmGroup.get(configData?.dateEnabled?.from)?.value, configData?.displayFormat);
          let dateEnabledTo = configData?.dateEnabled?.to;
          let getMonth = dateEnabledTo?.indexOf('months') > -1 || dateEnabledTo?.indexOf('days') > -1 ? dateEnabledTo.split('-')[0] : false;
          let editableToDate = getMonth ? moment().add(getMonth, dateEnabledTo.split('-')[1]) : moment(frmGroup.get(configData?.dateEnabled?.to)?.value, configData?.displayFormat);
          
          let fromDateValue = configData?.dateEnabled?.from == 'today' ? moment() : frmGroup.get(configData?.dateEnabled?.from)?.value;
          let toDateValue = getMonth ? true : frmGroup.get(configData?.dateEnabled?.to)?.value;
          let currentFieldValue = moment(frmGroup.get(name).value, configData?.displayFormat);
          let displayFormatLength = configData?.displayFormat?.indexOf('A') > -1 || configData?.displayFormat?.indexOf('a') > -1 ? configData?.displayFormat?.length + 1 : configData?.displayFormat?.length;
          
          // Validate against 'from' date if available
          if (fromDateValue && frmGroup?.get(name)?.value?.length == displayFormatLength) {
            if (currentFieldValue.isBefore(editableFromDate)) {
              let error = {
                message: {
                  configDataLabel: "",
                  additionalLabel: configData?.dateEnabled?.errorMsg
                    ? configData?.dateEnabled?.errorMsg
                    : configData?.dateFormatErrorMessage,
                  fieldLabel: "",
                }
              };
              error[name] = true;
              frmGroup.get(name).setErrors(error);
              return {'error': true,  message : error.message};
            }
          }
          
          // Validate full range if both dates are available
          if (fromDateValue && toDateValue) {
            let vaildDateStatus = currentFieldValue.isBetween(editableFromDate, editableToDate, undefined, '[]');
            if (!vaildDateStatus && (frmGroup?.get(name)?.value?.length == displayFormatLength)) {  
              let error = {
                message: {
                  configDataLabel: "",
                  additionalLabel: configData?.dateEnabled?.errorMsg
                    ? configData?.dateEnabled?.errorMsg
                    : configData?.dateFormatErrorMessage,
                  fieldLabel: "",
                }
              };
              error[name] = true;
              frmGroup.get(name).setErrors(error);
              return {'error': true,  message : error.message};
            }
          }
        
        }
        //End//
      }
      if (configData?.checkDateEnabled && configData?.checkDateEnabled === true) {
        if (configData.dateEnabled) {
          let name = configData.name
          let dateEnabledFrom = configData?.dateEnabled?.from;
          let dateEnabledTo = configData?.dateEnabled?.to;
          let editableFromDate = dateEnabledFrom === 'today' ? moment() : dateEnabledFrom?.includes('-') ? moment().subtract(parseInt(dateEnabledFrom.split('-')[1]), dateEnabledFrom.split('-')[2]) : frmGroup.get(dateEnabledFrom).value;
          let getMonth = dateEnabledTo?.includes('-') ? parseInt(dateEnabledTo.split('-')[0]) : false;
          let editableToDate = dateEnabledTo === 'today' ? moment() : getMonth ? moment().add(getMonth, dateEnabledTo.split('-')[1]) : frmGroup.get(dateEnabledTo).value;
          
          let fromDateAvailable = dateEnabledFrom === 'today' || dateEnabledFrom?.includes('-') || frmGroup.get(dateEnabledFrom)?.value;
          let toDateAvailable = dateEnabledTo === 'today' || getMonth || frmGroup.get(dateEnabledTo)?.value;
          let currentFieldValue = moment(frmGroup.get(name).value, configData?.displayFormat);
          let displayFormatLength = configData?.displayFormat?.indexOf('A') > -1 || configData?.displayFormat?.indexOf('a') > -1 ? configData?.displayFormat?.length + 1 : configData?.displayFormat?.length;
          
          // Validate against 'from' date if available
          if (fromDateAvailable && frmGroup?.get(name)?.value?.length == displayFormatLength) {
            if (currentFieldValue.isBefore(editableFromDate)) {
              let error = {
                message: {
                  configDataLabel: "",
                  additionalLabel: configData?.dateEnabled?.errorMsg
                    ? configData?.dateEnabled?.errorMsg
                    : configData?.dateFormatErrorMessage,
                  fieldLabel: "",
                }
              };
              error[name] = true;
              frmGroup.get(name).markAsTouched();
              frmGroup.get(name).setErrors(error);
              return { 'error': true, message: error.message };
            }
          }
          
          // Validate full range if both dates are available
          if (fromDateAvailable && toDateAvailable) {
            let vaildDateStatus = currentFieldValue.isBetween(editableFromDate, editableToDate, undefined, '[]');
            if (!vaildDateStatus && (frmGroup?.get(name)?.value?.length == displayFormatLength)) {
              let error = {
                message: {
                  configDataLabel: "",
                  additionalLabel: configData?.dateEnabled?.errorMsg
                    ? configData?.dateEnabled?.errorMsg
                    : configData?.dateFormatErrorMessage,
                  fieldLabel: "",
                }
              };
              error[name] = true;
              frmGroup.get(name).markAsTouched();
              frmGroup.get(name).setErrors(error);
              return { 'error': true, message: error.message };
            }
          }
        }
      }
    }

//PORTALNA-7826 AirBus_UAT_Defect_5650 - Export License dates automatically populating invalid date.
    if(configData?.displayFormat)
    {
      let formFieldValue= frmGroup.get(configData.name).value
      let isValidFormatField = moment(formFieldValue, configData?.displayFormat, true).isValid();
      if (!isValidFormatField && formFieldValue != "") {
        let error = {
          message: {
            "configDataLabel": configData.dateFormatErrorMessage || "MAR.SEARCH_ORDER.searchFilter.wrongDateError",
            "dateFormat": !configData.dateFormatErrorMessage ? configData.placeHolder : ""
          }
        }
        console.log(error)
        error[name] = true;
        frmGroup.get(name).markAsTouched();
        frmGroup.get(name).setErrors(error);   // change in html
        fieldError = true;
        return { 'error': true, message: error.message };
      }
    }
    //end

    const isValid = frmGroup.get(name).valid;
    if (isValid && (configData.pastDaysLimit)) {
      const formFieldValue = frmGroup.get(configData.name).value
      const givenDate = moment(formFieldValue, configData?.displayFormat, true);
      const today = moment();
      const minDate = moment(today).subtract(configData.pastDaysLimit, 'days');

      if (givenDate.isBefore(minDate)) {
        const error = {
          message: {
            "configDataLabel": `Date cannot be earlier than ${configData.pastDaysLimit} days`,
          },
          [name]: true
        }

        frmGroup.get(name).markAsTouched();
        frmGroup.get(name).setErrors(error);   // change in html
        fieldError = true;
        return { 'error': true, message: error.message };
      }
    }

    return { 'error': fieldError };
  }

  public setErrorFn = (error, frmGroup, name) => {
    error[name] = true;
    frmGroup.get(name).markAsTouched();
    frmGroup.get(name).setErrors(error);
    return { 'error': true, message: error.message };
  }

  public showError = (errorType, errorMsg, frmGroup, name) => {
    let error = {
      message: { "additionalLabel": errorMsg },
    }
    error["type"] = errorType;
    error[name] = true;
    frmGroup.get(name).markAsTouched();
    frmGroup.get(name).setErrors(error);
    return { 'error': true, message: error.message };
  }

  public formatDateMoment(date,reqformat) {
    let dDate = date;
    let formatedDate;
    if(dDate)
    {
      //if date is provided then apply given format
      //formatedDate = moment(date).format(reqformat);
      formatedDate = moment(date).format(reqformat);
    }
    else
    {
      //if date is not provided then apply given format to current date
      formatedDate = moment().format(reqformat);
    }
    return formatedDate;
  }
  
  // public setDateValidator(configData: any): ValidatorFn {
  //   return (control): { [key: string]: any } | null => {
  //     let dateIs = configData?.displayFormat ? moment(control?.value, configData?.displayFormat).format('MM/DD/YYYY hh:mm A') : control?.value;
  //     if (!dateIs) {
  //       if(configData.required){
  //         return { required: true }
  //       }
  //       return null;
  //     }

  //     const momentDate = moment(dateIs);
  //     const isValidDate = momentDate.isValid();
  //     if (!isValidDate) {
  //       let error = {
  //         message: { "configDataLabel": "MAR.SEARCH_ORDER.searchFilter.wrongDateError", "dateFormat": configData.placeHolder }
  //       }
  //       error[configData.name] = true;
  //       return error;
  //     }
  //     return null;
  //   }
  // }

  public formatDateForExport(t) {
    var d = new Date(t),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear(),
      hour = '' + d.getHours(),
      min = '' + d.getMinutes(),
      sec = '' + d.getSeconds()

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    if (hour.length < 2)
      hour = '0' + hour;
    if (min.length < 2)
      min = '0' + min;
    if (sec.length < 2)
      sec = '0' + sec;

    return [month, day, year].join('/') + ' ' + [hour, min, sec].join(':');
  }
  public formatcreatedDateUTC(t) {
    let n = new Date();
    var d = new Date(t),
      month = '' + (d.getUTCMonth() + 1),
      day = '' + d.getUTCDate(),
      year = d.getUTCFullYear();
    let hour = n.getUTCHours().toString();
    let min = n.getUTCMinutes().toString();
    let sec = n.getUTCSeconds().toString();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    if (hour.length < 2) {
      hour = '0' + hour;
    }
    if (min.length < 2) {
      min = '0' + min;
    }
    if (sec.length < 2) {
      sec = '0' + sec;
    }

      return [year, month, day].join("-") + "T" + [hour, min,sec].join(':')+"Z"; 
    }

  public formatDate(t) {
    let n = new Date();
    var d = new Date(t),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    let hour = n.getHours().toString();
    let min = n.getMinutes().toString();
    let sec = n.getSeconds().toString();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
      if(hour.length<2)
      {
        hour = '0'+hour;
      }
      if(min.length<2)
      {
        min = '0'+min;
      }
      if(sec.length<2)
      {
        sec = '0'+sec;
      }

    return [year, month, day].join("-");
  }

  public formatDateForExportDatepicker(t) {
    let n = new Date();
    let d = new Date(t),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    let hour = n.getHours();
    let min = n.getMinutes();
    let sec = n.getSeconds();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [year, month, day].join('-') + ' ' + [hour, min, sec].join(':');
  }

  public getSystemDateMMddyyyy(t) {
    let c = new Date(t);
    if(isNaN(c.getTime())) {
      return t;
    }

    let d = new Date(c +"UTC"),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [month, day, year].join('/');
  }

  public getSystemDateMMddyyyy_withoutTimeFormat(t) {
    let c = new Date(t);
    if(isNaN(c.getTime())) {
      return t;
    }

    let d = new Date(c.toUTCString()), // Using here toUTCString() to get UTC date
      month = '' + (d.getUTCMonth() + 1),
      day = '' + d.getUTCDate(),
      year = d.getUTCFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    
    return [month, day, year].join('/');
  }

  public updateControlName(ctrl, index) {

    if (ctrl['controls']) {

      ctrl['controls'].map(c => {
        c.name += index;
        if (c['events'])
          this.updateEventPropsName(c, index);
        if (c['controls']) {
          c['controls'].map(d => {
            d.name += index;
            if (d['events'])
              this.updateEventPropsName(d, index);
            if (d['controls']) {
              d['controls'].map(e => {
                e.name += index;
                if (e['events'])
                  this.updateEventPropsName(e, index);
              })
            }
          })
        }
      })
    }
    return ctrl;
  }

  public applydateformat(tableHeaders,tableRows, dateFormattedColumns?) {
    console.log(dateFormattedColumns);
    const LocalFunction = this.setLocalTime;
    tableRows.forEach(item => {
      tableHeaders.forEach(element => {
        if(element['primaryText'].value && element['primaryText'].value.length > 0) {
          if(element['primaryText'].localDate) {
            element['primaryText'].localDate.forEach(function(localDate, idx){
              if(localDate) {
                let dateField = element['primaryText'].value[idx];
                let dFormat = dateFormattedColumns[dateField].localFormat;
                if(item[dateField]) {
                  let localTime = LocalFunction(item[dateField], dFormat);
                  item[dateField] = localTime;
                }
              }
            });
          }
        }
        if(element['primaryText'].value && element['primaryText'].value.length > 0) {
          if(element['primaryText'].format) {
            element['primaryText'].format.forEach(function(dFormat, idx){
              if(dFormat) {
                let dateField = element['primaryText'].value[idx];
                if(item[dateField]) {
                  item[dateField] = moment(item[dateField]).format(dFormat).toUpperCase();
                }
              }
            });
          }
        }
      });
    });
  }

  public setLocalTime(dateField, format){
    dateField = moment.utc(dateField,format).local();
    dateField = moment(dateField).format(format).toUpperCase();
    return dateField;
  }

  public setLocalTimeForMultipleFormat(dateField, sourceFormat, targetFormat) {
    return moment
      .utc(dateField, sourceFormat)
      .local()
      .format(targetFormat);
  }

  public updateEventPropsName(control, index) {
    control['events'].map(e => {
      e['props'].map(p => {
        p.name += index;
      })
    })
  }

  checkContactPage() {
    let custCode = localStorage.getItem('customerCode');
    if (this.ContactList.indexOf(custCode) > -1) {
      return true;
    }
    return false;
  }

  errorHandling(statusCode) {
    if (statusCode.errorSource === "top") {
      let topec = statusCode.errorCode;
      let topcodes: any = (backenderrorData as any).default;
      if (Array.isArray(topcodes)) {
        const errorMsgPopup = topcodes.find(code => code.errorCode == topec);
        return errorMsgPopup.statusMessage;
      }
    }
    else {
      return statusCode.statusMessage;
    }
  }

  public getDifferenceInDays(date_future){
    let delta;
    delta = (date_future - Number(new Date())) / 1000;

    // calculate (and subtract) whole days
    let days = Math.floor(delta / 86400);
    delta -= days * 86400;

    return days;
  }
  public getDifferenceBetweenDates(date_future, date_now, flag,ignore0days=false, isMinutesAndDueRequired=true) {
    let delta;
    let durOrOverdue = ' due';
    if (flag === true) {
      delta = Math.abs(date_future - date_now) / 1000;
      durOrOverdue = ' due';
    } else {
      delta = Math.abs(date_now - date_future) / 1000;
      durOrOverdue = ' overdue';
    }

    // calculate (and subtract) whole days
    let days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    let hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    let minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    if(ignore0days){
      let time = (days ? days + " days " :"")+(hours || days ? hours + " hours " :"")+ minutes + " minutes";
      return time;
    }

    if(!isMinutesAndDueRequired){
      return days + " days "+ hours + " hours " + (!flag ? durOrOverdue : '' );
    }
    return days + " days "+ hours + " hours " + minutes + " minutes " + durOrOverdue;

  }
  // provide normal correct date string as argument
  // provide simpleFormat data like DD/MM/YYYY
  // simple method to convert UTC date into browser or system date
  public getSystemDate(date, simpleFormat=null, time =null){
    let utcDate = new Date(date);
    let systemDate = new Date(utcDate+'UTC');
    let finalSystemDate = systemDate.toString();

    if(simpleFormat){
      let month = '' + (systemDate.getMonth() + 1),
      day = '' + systemDate.getDate(),
      year = systemDate.getFullYear();
      let hour = systemDate.getHours();
      let min = systemDate.getMinutes();
      let sec = systemDate.getSeconds();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
	  if( simpleFormat == 'MM/DD/YYYY'){
		finalSystemDate= [month, day, year].join('/');
	  } else if(simpleFormat == 'MM-DD-YYYY'){
		finalSystemDate = [month, day, year].join('-');
	  } else if(simpleFormat == 'YYYY-MM-DD'){
		finalSystemDate = [year, month, day].join('-');
	  }
	  if(time){
		finalSystemDate += ' ' + [hour, min, sec].join(':');
	  }
	}
	return finalSystemDate;
  }

  public getDecodedAccessToken(token: string): any {
    try{
        return jwt_decode(token);
    }
    catch(Error){
        return null;
    }
  }

 // This method has been designed to compare two object by checking their property only
  public compareTwoObj(one, two){
    return JSON.stringify(one).indexOf(JSON.stringify(two)) > - 1;
  }
  public azureLogout(data? : boolean){
    // window.location.href = 'https://login.microsoftonline.com/cd99fef8-1cd3-4a2a-9bdf-15531181d65e/oauth2/logout?post_logout_redirect_uri=https%3A%2F%2Fdsctopna01dev2.dhl.com%2F';
    //Cp-3234 -start
    let customerCode = localStorage.getItem("customerCode")
    let businessObjectIds =JSON.parse(sessionStorage.getItem("businnessObjIds"));
    let userName = localStorage.getItem('userName');
    let url =localStorage.getItem("defaultHomepage");
    if ( customerCode === "COX" && businessObjectIds) {
      this.releaseLockedOrders(businessObjectIds,customerCode,userName,url);
    }//Cp-3234 -end
    let isCookieConsentSet = this.cookieService.get('setConsent');
    sessionStorage.clear();
    localStorage.clear();
    // NCP-15230-start If cookie consent already accpeted by user then it won't ask again until user manually delete it from Cookie
    if(isCookieConsentSet === "true") {
      this.cookieService.set('setConsent', "true");
    }
    // NCP-15230-end
    this.cookieService.delete('id_token');
    this.cookieService.delete('authToken');
    //NCP-14715-start Adding Condition to below line because after logout screen is loading and login funtion is not going to call due to this logoutMode
	  if(data === true) {
      sessionStorage.setItem('logoutMode', 'YES');
    }
    //NCP-12715-end
    window.location.href = this.azureConfiguration.azureBaseUrl + this.azureConfiguration.tenant + '/oauth2/logout?post_logout_redirect_uri=' +
    this.azureConfiguration.postLogoutRedirectUri;
  }

  public azureLogin(){

  }

  public initiateAzureLogin(){
    let isCookieConsentSet = this.cookieService.get('setConsent');
    localStorage.clear();
    sessionStorage.clear();
    // NCP-15230-start If cookie consent already accpeted by user then it won't ask again until user manually delete it from Cookie
    if(isCookieConsentSet === "true") {
      this.cookieService.set('setConsent', "true");
    }
    let timestamp = +new Date();
    let clientId= 'ecb686e4-516d-4f15-befe-d64b1ec94446';
    let url = 'https://login.microsoftonline.com/cd99fef8-1cd3-4a2a-9bdf-15531181d65e/oauth2/authorize?response_type=id_token code&client_id='
              + clientId
              + '&redirect_uri=' + window.location.origin + '/login'
              + '&nonce=' + timestamp;
    window.location.href = url;
  }

  private azureConfiguration = {
    azureBaseUrl: 'https://login.microsoftonline.com/',
    tenant: 'cd99fef8-1cd3-4a2a-9bdf-15531181d65e',
    clientId: 'ecb686e4-516d-4f15-befe-d64b1ec94446',
    redirectUri: window.location.host + '/login',
    postLogoutRedirectUri: window.location.origin
  }

  //Cp-3234 - start- Orders should be unlocked from the current user if inactive for more that 5 minutes
  public releaseLockedOrders(businnessObjId, customerCode, userName, homeUrl) {
    let requestType = "release";
    let url = APP_Constants.COX_ORDER_SUBMIT;
    url += '?customerCode=' + customerCode;
    url += '&userId=' + userName + '&action=releaseBussinessObject';
    let businnessObjIds = businnessObjId;
    let payload = {
      "requestType": requestType,
      "dhlCustomer": customerCode,
      "businessObjectIds": businnessObjIds.map(String)
    }

    this.makeHttpPostRequest(url, payload).subscribe((response) => {
      this.router.navigateByUrl(homeUrl);
    })
  }//cp-3234 -end

  refreshCalled: boolean = false;

  public refreshToken(expiresIn) {
    setTimeout(() => {

      if (sessionStorage.getItem("UserIdle10") == 'false'){
        this.callTokenAPI()
      }

      else { //CP-4207
        // let initiateLogin = setTimeout(() => {
        //   this.azureLogout();
        // }, 4 * 60 * 1000);

        let message = "User session is about to end. Please confirm to extend the user session.";

        let configInitiateLogin = {
          actions: true, type: 'confirm', name: "Session Timeout", title: "Session Timeout", description: message,
          actionButtonText: "Extend",
          // secondaryAction: "Cancel",
          noCancelButton :true,
          imgIcon: '../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1350,24,24))',
          style: { width: "600px", height: "200px" }
        }
        let modalConfigInitiateLogin: MatDialogConfig<any> = new ModalConfig(configInitiateLogin);
        const subject = new Subject<boolean>();
        this.warningDlg = this.matDialog.open(GenericModalV2Component, modalConfigInitiateLogin);
        this.warningDlg.componentInstance.subject = subject;

        let redirectToLogin = setTimeout(() => {
          subject.next(false);
          subject.complete();
          this.warningDlg.close(false);
          console.log("NO ACTION BY USER AFTER POP UP");
        }, ((3* 60) + 45) * 1000); // 3 minutes 45 seconds

        this.warningDlg.afterClosed().subscribe(async response => {
          if (response === true) {
            // clearTimeout(initiateLogin);
            clearTimeout(redirectToLogin);
            this.callTokenAPI();
          }
          else if( response === false){
            let configRedirectToLogin = {
              actions: false, type: 'confirm', name: "Session Timeout Logout", title: "Session Timeout Logout", description: "User session has expired. Redirecting to login screen...",
              noCancelButton :true,
              imgIcon: '../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1350,24,24))',
              style: { width: "600px", height: "200px" }
            }
            let modalConfigRedirectToLogin: MatDialogConfig<any> = new ModalConfig(configRedirectToLogin);
            this.matDialog.open(GenericModalV2Component, modalConfigRedirectToLogin);
            setTimeout(()=>{
              if (environment.isSingleSignOn) {
                this.azureLogout();
              } else {
                this.router.navigateByUrl('/logout');
              }
            }, 5000);   // logout after 5 seconds of configRedirectToLogin popup
          }
        })
      }
    }, expiresIn);
  }


  callTokenAPI(){
    this.getRefreshTokenSilently().subscribe(response => {
      // implement tokenExpiry feature
      let expiry = (JSON.parse(atob(response['data'].accessToken.split('.')[1]))).exp;
      let tokenExpiry = Math.floor(expiry - (new Date().getTime()/1000)).toString();

      localStorage.setItem('tokenExpiry', tokenExpiry);
      localStorage.setItem('tokenExpiryTime', expiry);
      this.cookieService.set('authToken', response['data'].accessToken);
      // let lastTokenCall = (JSON.parse(atob(response['data'].accessToken.split('.')[1]))).iat;
      // localStorage.setItem('lastTokenCall', new Date(lastTokenCall*1000).toString());

      //cp-3498 -start
      let tokenExpiryTime = parseInt(tokenExpiry);//in seconds
      let tokenExpiresIn = (tokenExpiryTime - (6 * 60)) * 1000; //in milliseconds

      this.refreshToken(tokenExpiresIn);
      //cp-3498 -end
    }, error => {
      console.log(error);

      let errorModal = {
        actions: true, type: 'confirm', name: "Session Timeout Logout", title: "Session Timeout Logout", description: error.message,
        noCancelButton: true,
        actionButtonText: "OK",
        imgIcon: '../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1350,24,24))',
        style: { width: "600px", height: "200px" }
      }
      let modalConfigdirectToLogin: MatDialogConfig<any> = new ModalConfig(errorModal);
      this.warningDlg = this.matDialog.open(GenericModalV2Component, modalConfigdirectToLogin);
      const subject = new Subject<boolean>();
      this.warningDlg.componentInstance.subject = subject;
      this.warningDlg.afterClosed().subscribe(async response => {
        if (environment.isSingleSignOn) {
          this.azureLogout();
        } else {
          this.router.navigateByUrl('/logout');
        }

      })
    })
  }


  addValidators(control: AbstractControl, validators: ValidatorFn[]) {
    if (!validators || !validators.length) {
      return;
    }
    const { validator } = control;
    const newValidators: ValidatorFn[] = [validator];
    validators.forEach((vf: ValidatorFn) => {
      newValidators.push(vf);
    });
    control.setValidators(newValidators);
  }
  public toggleOtherComponent(res){
    let props = res.eventData.props;
    if(props){
      props.forEach(comp=>{
        if(res.data){
          if(comp.action == 'ENABLE'){
            this._components[comp.name].toggleDisable(true);
          }else if(comp.action == 'DISABLED'){
            this._components[comp.name].toggleDisable(false);
          }else if(comp.action == 'REQUIRED'){
            this._components[comp.name].configData.required = false;
          }else if(comp.action == 'NOT_REQUIRED'){
            this._components[comp.name].configData.required = true;
          }else{
            this._components[comp.name].toggleDisable(true);
          }
        }else{
          if(comp.action == 'ENABLE'){
            this._components[comp.name].toggleDisable(false);
          }else if(comp.action == 'DISABLED'){
            this._components[comp.name].toggleDisable(true);
          }else if(comp.action == 'REQUIRED'){
            this._components[comp.name].configData.required = true;
          }else if(comp.action == 'NOT_REQUIRED'){
            this._components[comp.name].configData.required = false;
          }else{
            this._components[comp.name].toggleDisable(false);
          }
        }
      })
    }
  }
  getTotalWeightAndVolume(weight, weightUOMCode, volume, volumeUOMCode) {
    let totalWeight = weight + " " + weightUOMCode;
    let weightUom = this.ConvertUomPipe.transform(totalWeight, "");
    let totalVol = volume + " " + volumeUOMCode;
    let volUom = this.ConvertUomPipe.transform(totalVol, "");
    let weightVolume = weightUom + " | " +  volUom;
    return weightVolume
  }

  addCSVHeaders(item, csvHeaders, screen = '') {
    let uomData = localStorage.getItem('preferredUOM');
    csvHeaders.forEach(csvHeader => {
      if (csvHeader?.formatDate) {
        item[csvHeader.title] = "=\"" + item[csvHeader.key] + "\"";
      } else {
        let values;
        csvHeader.key.forEach((element, index) => {
          if (csvHeader.key.length > 1) {
            if (csvHeader.uomPref && uomData !== null) {
              if (screen === 'order')
                values = this.getTotalWeightAndVolume(item["TOTAL_WEIGHT"], item["TOTAL_WEIGHT_UOM_CODE"], item["TOTAL_VOLUME"], item["TOTAL_VOLUME_UOM_CODE"]);
              else if (screen === 'release')
                values = this.getTotalWeightAndVolume(item["WEIGHT"], item["WEIGHT_UOM"], item["VOLUME"], item["VOLUME_UOM"]);
            }
            else {
              if (csvHeader.key.length > index + 1)
                values = item[element] + " " + csvHeader.separator + " ";
              else
                values += item[element];
            }
          }
          else {
            values = item[element];
          }
        });
        item[csvHeader.title] = values;
      }
    })
    return item;
  }
  getDateFormatDisplay(date) {
    let convertDate = moment(date).format("DD-MMMM-YYYY");
    return convertDate;
  }

  getDateFormat(date) {
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
  }
   
  getDateMonthFormat(date,dateFormat) {
    let formatedDate = moment(date).format(dateFormat);
     return formatedDate;
   }
   
  //CP-2434 : start : dateformat change on reset button
  formatDateValueForCox(control, data, setDate: boolean = false) {
    let formValue;
    let format = control['format'];
    let type = control['dataType'];
    // To show dates in human readable format on screen but send the date in UTC/ISO/machine readable use type: 'OBJECT' in template
    if (type === 'OBJECT') {
      if (data && typeof data !== 'object') {
        //START - CP-3509 : Fix the date picker time zone
        if(setDate){
          formValue = { 'displayValue': this.getDateFormat(new Date(data)), 'value': data };
        }else{
          if(control?.convertToSystemDate === false){
            formValue = { 'displayValue': this.getSystemDateMMddyyyy_withoutTimeFormat(data), 'value': data };
          } else {
            formValue = { 'displayValue': this.getSystemDateMMddyyyy(data), 'value': data };
          }
        }
        //END - CP-3509 : Fix the date picker time zone
      } else {
        formValue = data;
      }
    } else {
      formValue = data;
    }
    try {
      if (format === 'ISO') {
        if (typeof formValue === 'object' && formValue.value && formValue.value.length <= 10 && type === 'OBJECT') {
          formValue['value'] = new Date(this.formatDateForExportDatepicker(formValue.value)).toISOString().slice(0, -1);
        } else if (typeof formValue === 'string' && formValue && formValue.length <= 10) {
          formValue = new Date(this.formatDateForExportDatepicker(formValue)).toISOString().slice(0, -1);
        }
      } else {
        if(format && formValue){
          formValue = moment(formValue).format(format);
        }
      }
    }
    catch (e) {
      formValue = formValue;
    }
    return formValue;
  }//CP-2434 : end

  showInlineMessage(type: 'success' | 'error', message: string) {
    switch (type) {
      case 'success':
        this.inlineSuccessMessage = message;
        break;
      case 'error':
        this.inlineErrorMessage = message;
        break;
    }
  }

  public getJSON(url): Observable<any> {
    return this.http.get(url);
  }
    
  public compareTwoNumericFields(configData: any, frmGroup: any, reValidateOtherField = true) {
    let fieldValue = frmGroup?.get(configData?.name)?.value;
    let fieldWarning = false;

    if (fieldValue) {
      for (const check in configData.validation) {
        let validationCheck = configData?.validation[check]?.split('-');
        let nextFieldValue = frmGroup.get(validationCheck[1])?.value;

        if (validationCheck[0] === "notLessThan" && fieldValue && nextFieldValue) {
          if (Number(fieldValue) < Number(nextFieldValue)) {
            let warning = {
              message: { "configDataLabel": configData.warningMsg },
            }
            fieldWarning = true;
            return { 'warning': true, message: warning.message };
          }
        } else if (validationCheck[0] === "notGreaterThan"  || validationCheck[0] === "notMoreThan") {
          if (Number(fieldValue) > Number(nextFieldValue)) {
            let warning = {
              message: { "configDataLabel": configData.warningMsg },
            }
            fieldWarning = true;
            return { 'warning': true, message: warning.message };
          }
        }

        if ((validationCheck[0] === "notGreaterThan" || validationCheck[0] === "notLessThan") && reValidateOtherField) {
          const validity = this.compareTwoNumericFields(this._components[validationCheck[1]]?.configData, frmGroup, false);
          if (!validity.warning && this._components[validationCheck[1]]?.infoMsg?.warning) {
            this._components[validationCheck[1]].infoMsg.warning = false;
          }
        }
      }
    }
    return { 'warning': fieldWarning };
  }

  public checkPastDate(configData: any): ValidatorFn {
    return (control): { [key: string]: any } | null => {
      if (!control.value) {
        if (configData.required) {
          return { required: true }
        }
        return null;
      }

      let isPastDate = false;
      let dateIs = configData?.displayFormat ? moment(control?.value, configData?.displayFormat).format('MM/DD/YYYY hh:mm A') : control?.value;
      if (!configData?.timePicker){
        isPastDate = moment(dateIs).isBefore(moment().startOf('day').toDate());
      }
      else{
        isPastDate = moment(dateIs).isBefore(new Date());

      }
      if (isPastDate) {
        let error = {
          message: { "configDataLabel": configData.label, "additionalLabel": configData.pastDateErrorMessage, "fieldLabel": "" },
        }
        error[configData.name] = true;
        return error;
      }
      return null;
    }
  }

  public checkFutureDate(configData: any): ValidatorFn {
    return (control): {[key: string]: any} | null => {
      if (!control.value){
        if(configData.required){
          return {required: true};
        }
        return null;
      }
      let isFutureDate = false;
      let dateIs = configData?.displayFormat ? moment(control?.value,configData?.displayFormat).format('MM/DD/YYYY hh:mm A'): moment(control?.value).format('MM/DD/YYYY hh:mm A');

      if(!configData?.timepicker) {
        isFutureDate = moment(dateIs).isAfter(moment());
      } else {
        isFutureDate = moment(dateIs).isAfter(new Date());
      }
      if(isFutureDate){
        let error = {
          message: {"configDataLabel": configData.label, "additionalLabel": configData.futureDateErrorMessage || "cannot be in the future", "fieldLabel": "" }
        };
        error[configData.name] = true;
        return error;
      }
      return null;
    };
  }

  public checkOneMonthPast(configData: any): ValidatorFn {
    return (control): {[key: string]: any} | null => {
      if (!control.value){
        if(configData.required){
          return {required: true};
        }
        return null;
      }
      let isBeforeOneMonth = false;
      let dateIs = configData?.displayFormat?moment(control?.value,configData?.displayFormat).format('MM/DD/YYYY hh:mm A'): control?.value;
      let oneMonthAgo = moment().subtract(1,'months').startOf('day');
      if(!configData?.timepicker) {
        isBeforeOneMonth = moment(dateIs).isBefore(oneMonthAgo);
      } else {
        isBeforeOneMonth = moment(dateIs).isBefore(oneMonthAgo);
      }
      if(isBeforeOneMonth){
        let error = {
          message: {"configDataLabel": configData.label, "additionalLabel": configData.oneMonthPastDateErrorMessage || "cannot be earlier than one month", "fieldLabel": "" }
        };
        error[configData.name] = true;
        return error;
      }
      return null;
    };
  }
  separatePascalCase(val){
    if(val){
      let status = val;
      let updatedStatus = "";
        if (val.toString().startsWith('3P')){
          updatedStatus = val.toString().substring(0,2);
          status = val.toString().substring(2);
        }
        status=status.replace(/([A-Z]+)([A-Z][a-z])/g, ' $1 $2')
        .replace(/([a-z\d])([A-Z])/g, '$1 $2')
        .replace(/([a-zA-Z])(\d)/g, '$1 $2')
        .replace(/^./, function(str){ return str.toUpperCase(); })
        .trim();
        if(updatedStatus){
            status = updatedStatus+" "+status;
        }
        val=status;
      }

    return val;
  }

  public dynamicWarningMsg(configData: any, frmGroup: any, msg: any) {
    let fieldValue = frmGroup?.get(configData?.name)?.value;
    let fieldWarning = false;
    let warning;
    if (fieldValue && msg == APP_Constants.MATCH) {
      configData.warningMsg = configData.matchMsg
      warning = {
        message: { "configDataLabel": configData.warningMsg },
      }
      fieldWarning = true;
      return { 'warning': true, message: warning.message };
    } else if (fieldValue && msg == APP_Constants.NO_MATCH) {
      configData.warningMsg = configData.noMatchmsg
      warning = {
        message: { "configDataLabel": configData.warningMsg },
      }
      fieldWarning = true;
      return { 'warning': true, message: warning.message };
    } else if (fieldValue && msg === APP_Constants.MULTIPLE_MATCH) {
      configData.warningMsg = APP_Constants.MULTIPLE_MATCH;
      warning = {
        message: { "configDataLabel": configData.warningMsg },
      }
      fieldWarning = true;
      return { 'warning': true, message: warning.message };
    } else {
      warning = {
        message: { "configDataLabel": configData.warningMsg }
      }
      fieldWarning = true;
      return { 'warning': true, message: warning.message };
    }
  }

   public getCurrentUrl(){
    return this.currentUrl;
  }
}


// Back-End response (applies to all template, data call)
// =========================================================

// Error Case(401, 403, 503, 404) -- let me know if http code is missing here
// -------------------------------------------------
// {
//           "message": {
//                    "statusCode": "ERROR",
//                    "statusMessage": "No data found" -- message is subject to change
//           },
//           "data": {
//                    "userData": [blank]                     -- can be JSON: {blank}
//           }
// }

// Success Case(200)
// -----------------------------------------------------
// {
//           "message": {
//                    "statusCode": "SUCCESS",
//                     "statusMessage": "Data found"              -- message is subject to change
//           },
//           "data": {
//                    "userData": [json]                       --- can be JSON : {data}
//           }
// }

// Other http code like 500, I will show "Something bad happened ..."


// Form-submission request structure from UI for HTTP POST(example: Create, Edit, Release order)
// ===========================================================

// request body  :
// {
//           "data": {
//                    "param": {},
//                    "table": []
//           }
// }

// Other UI HTTP POST call
// -----------------------------------------------------------
// request body  :
// {
//          "data": {
//                   "key": "value",
//                    "key": "value"
//          }
// }